import { useRoute } from '#imports'
import { computed } from 'vue'

export function useGuestBmUserId() {
  const route = useRoute()

  const bmUserId = computed(() => {
    const value = route.query.bm_user_id

    return Array.isArray(value) ? value[0] : value
  })

  return { bmUserId }
}
